// import React from "react";
// import { XCircle } from "lucide-react"; 

// function PaymentFailure() {
//   return (
//     <div className="font-satoshi bg-red-50 min-h-screen flex items-center justify-center px-4">
//       <div className="bg-white p-8 md:p-10 rounded-xl shadow-xl max-w-md w-full text-center">
//         <div className="text-red-600 text-4xl mb-4 flex justify-center">
//           <XCircle size={48} />
//         </div>
//         <h1 className="text-2xl font-bold text-red-600 mb-2">Payment Failed</h1>
//         <p className="text-gray-700 text-base mb-6">
//           Unfortunately, your payment could not be processed. Please try again or contact support.
//         </p>
//         <a
//           href="/addVehicles/confirmation"
//           className="inline-block bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-6 rounded-md transition duration-200"
//         >
//           Try Again
//         </a>
//       </div>
//     </div>
//   );
// }

// export default PaymentFailure;

import React, {useState, useEffect}  from "react";
import { XCircle } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

function PaymentFailure() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("orderId");
  const amount = queryParams.get("amount");
  const flowFromState = location.state?.flow;
  const inspectionCodeFromState = location.state?.inspectionCode;
  const flowFromQuery = queryParams.get("flow");
  const inspectionCodeFromQuery = queryParams.get("inspectionCode");

  const paymentFlow = flowFromState || flowFromQuery || "accident";
  const inspectionCode = inspectionCodeFromState || inspectionCodeFromQuery;
  const redirectPath =
    paymentFlow === "inspection"
      ? inspectionCode
        ? `/inspection-report/${inspectionCode}`
        : "/inspection-reports"
      : "/addVehicles/confirmation";

  const [secondsLeft, setSecondsLeft] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          navigate(redirectPath, { replace: true });
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, redirectPath]);

  return (
    <div className="font-satoshi bg-red-50 min-h-screen flex items-center justify-center px-4">
      <div className="bg-white p-8 md:p-10 rounded-xl shadow-xl max-w-md w-full text-center">
        <div className="text-red-600 text-4xl mb-4 flex justify-center">
          <XCircle size={48} />
        </div>
        <h1 className="text-2xl font-bold text-red-600 mb-2">Payment Failed</h1>
        <p className="text-gray-700 text-base mb-2">
          Unfortunately, your payment could not be processed. Please try again or contact support.
        </p>

        {/* Display Order ID and Amount if available */}
        {orderId && (
          <p className="text-gray-600 text-sm mb-1">
            <strong>Order ID:</strong> {orderId}
          </p>
        )}
        {amount && (
          <p className="text-gray-600 text-sm mb-4">
            <strong>Amount Attempted:</strong> ₹{amount}
          </p>
        )}

        {/* <a
          href="/addVehicles/confirmation"
          className="inline-block bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-6 rounded-md transition duration-200"
        >
          Try Again
        </a> */}
        <p className="text-sm text-gray-700 font-semibold">
          Redirecting you in <span className="text-green-700 font-bold">{secondsLeft}</span> second{secondsLeft !== 1 ? "s" : ""}...
        </p>
      </div>
    </div>
  );
}

export default PaymentFailure;
